import { type FrameStats } from '@/core/time';

const REFRESH_MS = 100;

export class Hud {
  private readonly el: HTMLElement;
  private visible = false;
  private lastRender = 0;

  constructor(el: HTMLElement) {
    this.el = el;
  }

  setVisible(visible: boolean): void {
    if (this.visible === visible) return;
    this.visible = visible;
    this.el.classList.toggle('visible', visible);
    if (!visible) this.el.textContent = '';
  }

  toggle(): void {
    this.setVisible(!this.visible);
  }

  isVisible(): boolean {
    return this.visible;
  }

  render(nowMs: number, stats: FrameStats): void {
    if (!this.visible) return;
    if (nowMs - this.lastRender < REFRESH_MS) return;
    this.lastRender = nowMs;
    this.el.textContent =
      `FPS   ${stats.fps.toFixed(1)}\n` +
      `FRAME ${stats.frameMs.toFixed(2)} ms\n` +
      `CPU   ${stats.cpuMs.toFixed(2)} ms\n` +
      `DRAW  ${stats.drawCalls.toString()}\n` +
      `TRIS  ${stats.triangles.toString()}\n` +
      `INST  ${stats.instances.toString()}`;
  }
}
